// Create Prompt

export const headers = `{
  "Content-Type": "application/json",
  "Authorization": "Bearer <YOUR_TOKEN_HERE>"
}`;

const commonCode = `
"businessGroup": '<Business_Group>',
"promptName": '<Prompt_Name>',
"promptVersion": '<Prompt_Version>',                  # Version of the Prompt ,as default use "1"
"llmTestedWith": '<LLM_Tested_With>',
"is_prompt_type_private": "<SingleTurn>",             # True/False , any value 
"is_interaction_type_single": "<InteractionType>",    # True/False , any value 
"promptDescription": '<Prompt_Description>',
"systemPrompt":  '<System_Prompt>',`;

const otherCodes = `
  "roles": <Role>,
  "variables": <Variable_Data>`;

export const CreatePromptEndPoint = { type: 'POST', url: '/submit_page/' };
export const CreatePromptTemplate = `{
"prompt": {${commonCode}
          "prompt": <Prompt>                          # if is_interaction_type_single is True , otherwise remove it
    },
          ${otherCodes}
}`;

// DeletePrompt
export const DeletePromptEndPoint_Version = {
  type: 'DELETE',
  url: '/my_prompts/<PROMPT_ID>/versions/<VERSION_ID>?deleteMaster=false&deletVersion=true'
};

export const DeletePromptEndPoint_Master = {
  type: 'DELETE',
  url: '/my_prompts/<PROMPT_ID>/versions/<VERSION_ID>?deleteMaster=true&deletVersion=false'
};

export const DeletePromptTemplate = `{}`;

// Edit Prompt
export const EditPromptEndPointNewVersion = {
  type: 'PUT',
  url: '/my_prompts/<PROMPT_ID>?mode=update&base_version_no=<VERSION_NUMBER>'
};

export const EditPromptEndPointSameVersion = {
  type: 'PUT',
  url: '/my_prompts/<PROMPT_ID>?'
};

export const EditPromptTemplate = `{    
    "prompt": {
        "selectedApplication": "",
        ${commonCode}
        "usageExample": '<Usage_Example>',
        "totalVersions": '<Total_Versions>',
    },
    ${otherCodes}
}
`;

// Fetch All Prompts
export const GetAllPromptsEndPoint = {
  type: 'GET',
  url: '/prompt_lib_new/'
};
export const GetAllPromptsTemplate = `{}`;

// Fetch Specific Prompt
export const GetPromptEndPoint = {
  type: 'GET',
  url: '/my_prompts/<PROMPT_ID>'
};
export const GetPromptTemplate = `{}`;
// Save Prompt
export const SavePromptEndPoint = {
  type: 'POST',
  url: '/playground_save/save_from_lib'
};

export const SavePromptTemplate = `{
  ${commonCode}
  ${otherCodes}
}
`;
